import api from "../../core/api";
import { Page } from "../../shared/models/models";
import { AdminOffer, AdminOffersQuery } from "../models/AdminOffersModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.tradingBaseUrl };
}

class AdminOffersApi {
  getOffers(query: AdminOffersQuery): Promise<Page<AdminOffer>> {
    return api.get<Page<AdminOffer>>(`/v1/admin/offers`, { ...getRequestConfig(), params: query })
      .then(x => x.data);
  }

  getOffer(id: string): Promise<AdminOffer> {
    return api.get<AdminOffer>(`/v1/admin/offers/${id}`, getRequestConfig()).then(x => x.data);
  }

  getOfferDocument(id: string) {
    return api.get<{data: Blob}>(`/v1/admin/offers/${id}/document`, {...getRequestConfig(), responseType: 'blob' })
  }

  deleteOffer(id: string): Promise<any> {
    return api.delete(`/v1/admin/offers/${id}`, getRequestConfig());
  }
}

export default new AdminOffersApi();